<template>
  <q-item
    :to="to"
    :tag="tag"
    :active="active"
    :clickable="clickable"
    :dense="dense"
    :disable="disable"
    @click="$emit('click')"
  >
    <slot />
  </q-item>
</template>

<script>
export default {
  name: 'Item',
  props: {
    to: [String, Object],
    tag: String,
    active: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
